import { find, noop } from 'underscore';
import React, { useCallback, useMemo } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { CommandButton, registerIcons } from '@fluentui/react';
import pinIcon from '../media/pin.svg';

registerIcons({
  icons: {
    'pin-icon': (<img style={{ position: 'absolute', left: -4 }} src={pinIcon} alt="chatgpt-logo" />),
  },
});
export function PinButton(props) {
  const {
    getPinItems,
    pinnedPosition,
    styles,
    onChange,
    className,
    i18n,
  } = props;
  const pinItems = getPinItems(i18n);
  const selectedText = useMemo(() => {
    const item = find(pinItems, c => c.key === pinnedPosition);
    return item.value;
  }, [pinItems, pinnedPosition]);

  const onMenuItemClick = useCallback((event, item) => {
    onChange(item.key);
  }, [onChange]);
  const onMenuClick = useCallback(() => {
    const pickerContainer = document.querySelector('.ad-strength-suggestion-container');
    if (pickerContainer) {
      ReactDOM.unmountComponentAtNode(pickerContainer);
    }
  }, []);
  return (
    <CommandButton
      className={`rsa-pin-button ${className}`}
      text={selectedText}
      menuIconProps={{ iconName: '' }}
      iconProps={{ iconName: 'pin-icon' }}
      menuProps={{
        items: pinItems,
        onItemClick: onMenuItemClick,
      }}
      onMenuClick={onMenuClick}
      styles={styles}
    />
  );
}

PinButton.propTypes = {
  getPinItems: PropTypes.func.isRequired,

  styles: PropTypes.shape({}),

  pinnedPosition: PropTypes.string,

  onChange: PropTypes.func,

  className: PropTypes.string.isRequired,

  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
};

PinButton.defaultProps = {
  pinnedPosition: 'None',
  onChange: noop,
  styles: {},
};
